import { memo } from 'react';
import PropTypes from 'prop-types';
// Import Components
import CustomerJourneyGeneralDetails from './CustomerJourneyGeneralDetails';

const CustomerJourneyDetails = ({
    schedule,
    mode,
    status,
    user,
    createdDate,
    lastModifier,
    lastModifiedDate,
    customFields,
}) => {
    return (
        <div className="details-page-wrapper">
            <div className="details-page-wrapper-inner cj-general-details-only">
                <div className="campaign-general-details">
                    <CustomerJourneyGeneralDetails
                        schedule={schedule}
                        mode={mode}
                        status={status}
                        user={user}
                        createdDate={createdDate}
                        lastModifier={lastModifier}
                        lastModifiedDate={lastModifiedDate}
                        customFields={customFields}
                    />
                </div>
            </div>
        </div>
    );
};

CustomerJourneyDetails.propTypes = {
    schedule: PropTypes.object.isRequired,
    mode: PropTypes.number.isRequired,
    status: PropTypes.number.isRequired,
    user: PropTypes.string.isRequired,
    createdDate: PropTypes.string.isRequired,
    lastModifier: PropTypes.string.isRequired,
    lastModifiedDate: PropTypes.string.isRequired,
    customFields: PropTypes.array,
};

export default memo(CustomerJourneyDetails);
